import { render, staticRenderFns } from "./CouponIdentificationList.vue?vue&type=template&id=31787dfa&scoped=true&"
import script from "./CouponIdentificationList.vue?vue&type=script&lang=js&"
export * from "./CouponIdentificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31787dfa",
  null
  
)

export default component.exports